(function(){
  function init(){
    var main=document.querySelector('#bp-root .bp-main');
    var mainimg=document.getElementById('bp-mainimg');
    if(!main||!mainimg) return;
    if(main.querySelector('.bp-gal-arrow')) return;

    var svgL='<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';
    var svgR='<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    var prev=document.createElement('button');
    prev.type='button';prev.className='bp-gal-arrow prev';
    prev.setAttribute('aria-label','Forrige billede');prev.innerHTML=svgL;

    var next=document.createElement('button');
    next.type='button';next.className='bp-gal-arrow next';
    next.setAttribute('aria-label','Næste billede');next.innerHTML=svgR;

    main.appendChild(prev);main.appendChild(next);

    function visible(){
      var out=[];
      document.querySelectorAll('#bp-root .bp-thumb').forEach(function(t){
        if(t.offsetParent!==null) out.push(t);
      });
      return out;
    }
    function sync(){
      var v=visible();
      var hide=v.length<2;
      prev.hidden=hide;next.hidden=hide;
    }
    function go(step){
      var v=visible();
      if(v.length<2) return;
      var i=0;
      for(var k=0;k<v.length;k++){ if(v[k].classList.contains('is-on')){i=k;break;} }
      var n=(i+step+v.length)%v.length;
      v.forEach(function(t){t.classList.remove('is-on');});
      v[n].classList.add('is-on');
      mainimg.src=v[n].getAttribute('data-src');
    }
    prev.addEventListener('click',function(e){e.preventDefault();go(-1);});
    next.addEventListener('click',function(e){e.preventDefault();go(1);});

    document.querySelectorAll('#bp-root .bp-sw').forEach(function(sw){
      sw.addEventListener('click',function(){window.setTimeout(sync,0);});
    });
    window.addEventListener('resize',sync);
    window.setTimeout(sync,0);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();